import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { authRoles } from "../../auth/authRoles";

const SiteSettings = Loadable(lazy(() => import("./SiteSettings")));

const settingsRoutes = [
  {
    path: "/settings/site",
    element: <SiteSettings />,
    auth: authRoles.superUser,
  },
];

export default settingsRoutes;
